import { useTranslation } from 'react-i18next';
import { waLink } from '@/context/CartContext';

const SOCIALS = [
  {
    icon: 'ri-instagram-line',
    label: 'Instagram',
    href: 'https://www.instagram.com/mehfil24_7',
  },
  {
    icon: 'ri-tiktok-fill',
    label: 'TikTok',
    href: 'https://www.tiktok.com/@mehfil24_7',
  },
  {
    icon: 'ri-youtube-line',
    label: 'YouTube',
    href: 'https://www.youtube.com/@mehfil24_7restaurant',
  },
  {
    icon: 'ri-whatsapp-line',
    label: 'WhatsApp',
    href: waLink('Hello Mehfil 24/7!'),
  },
];

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-background-900 py-14 text-background-100">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-4">
        <div>
          <a href="#home" className="flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500">
              <i className="ri-restaurant-2-line text-xl text-background-50"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-semibold text-background-50">Mehfil</span>
              <span className="text-[11px] tracking-[0.3em] uppercase text-accent-400">24 / 7</span>
            </span>
          </a>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
            {t('footer.desc')}
          </p>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50">{t('footer.links')}</h4>
          <ul className="mt-4 flex flex-col gap-3 text-sm text-background-300">
            {[
              { id: 'about', label: t('footer.about') },
              { id: 'menu', label: t('footer.menu') },
              { id: 'gallery', label: t('footer.gallery') },
              { id: 'contact', label: t('footer.contact') },
            ].map((l) => (
              <li key={l.id}>
                <a href={`#${l.id}`} className="transition-colors hover:text-accent-400">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50">{t('footer.touch')}</h4>
          <ul className="mt-4 flex flex-col gap-3 text-sm text-background-300">
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-2-line mt-0.5 text-accent-400"></i>
              <span>{t('info.address')}</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line text-accent-400"></i>
              <a href="tel:+37493951149" className="hover:text-accent-400">{t('info.phone1')}</a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-400"></i>
              hello@mehfil247.am
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50">{t('footer.follow')}</h4>
          <div className="mt-4 flex gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background-800 text-background-200 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className={`${s.icon} text-lg`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto mt-12 flex max-w-7xl flex-col items-center justify-between gap-3 border-t border-background-800 px-4 pt-6 sm:flex-row md:px-6">
        <p className="text-xs text-background-400">
          &copy; {year} Arman International LLC. {t('footer.rights')}
        </p>
        <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-background-400">
          {t('footer.curatedBy')} <span className="font-semibold tracking-wide text-accent-400">SKYEDGE INFOTECH LLC</span>
        </p>
      </div>
    </footer>
  );
}